import {
  termConditionResponse,
  privacySettingList,
} from "./privacy_policy.service";
export default {
  namespaced: true,
  state: {
    isLoading: false,
    termsCondition: null,
    privacySettings: null,
  },
  actions: {
    termConditionResponseAction: async ({ commit }, payload) => {
      try {
        commit("setLoading", true);
        const data = await termConditionResponse(payload);
        if (data && data.data) {
          commit("setTermsCondition", data.data);
        }
        return data;
      } catch (error) {
        console.error("Error fetching terms and conditions:", error);
      } finally {
        commit("setLoading", false);
      }
    },
    privacySettingListAction: async ({ commit }, tenant) => {
      try {
        commit("setLoading", true);
        const data = await privacySettingList(tenant);
        if (data && data.data) {
          commit("setPrivacySettings", data.data);
          return data;
        }
        return null;
      } catch (error) {
        console.error("Error fetching privacy settings:", error);
        return null;
      } finally {
        commit("setLoading", false);
      }
    },
  },
  mutations: {
    setLoading(state, isLoading) {
      state.isLoading = isLoading;
    },
    setTermsCondition(state, termsCondition) {
      state.termsCondition = termsCondition;
    },
    setPrivacySettings(state, privacySettings) {
      state.privacySettings = privacySettings;
    },
  },
  getters: {
    isLoading: (state) => state.isLoading,
    termsCondition: (state) => state.termsCondition,
    privacySettings: (state) => state.privacySettings,
  },
};
